import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from '../../store/snackbar-slice';
import { Maybe } from 'graphql/jsutils/Maybe';

const userInviteDetailsQuery = gql`
  query UserInviteDetails($token: String!) {
    userInviteDetails(token: $token) {
      _id
      name
      email
      invitedById
      invitedByName
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

function useUserInviteDetails(token: Maybe<string>) {
  const { data, loading, error } = useQuery(userInviteDetailsQuery, {
    fetchPolicy: 'cache-first',
    skip: !token,
    variables: {
      token,
    },
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (error) {
      console.error(error.message);
      dispatch(
        showMessage({
          _id: 'user-invite-details',
          severity: 'danger',
          message: 'There was an fetching your service request.',
        }),
      );
    }
  }, [error, dispatch]);
  return {
    userInvite: data?.userInviteDetails,
    loading,
  };
}

export default useUserInviteDetails;
